"use client";

import { useCallback, useRef } from "react";

export type Entity = "site_product" | 'product' | 'equivalent_path' | 'brand' | 'landing_page' | 'video' | 'homepage' | 'collection' | 'blog_post' | 'blog_category'
type EntityId = number | string | null | undefined;

export default function useView(entity: Entity, id: EntityId) {
	const hasSentRef = useRef(false);

	const sendView = useCallback(() => {
		// if (hasSentRef.current) return;
		if (id === null || id === undefined || id === "") return;

		hasSentRef.current = true;

		const token = localStorage.getItem("accessToken");
		const config: RequestInit = {
			method: "POST",
			credentials: "include",
			headers: {},
		};
		if (token) {
			config.headers["Authorization"] = `Bearer ${token}`;
		}

		void fetch(process.env.NEXT_PUBLIC_BASE_API_URL + `/api/v1/view/${entity}/${id}`, config).catch(() => {
			// silent fail
		});
	}, [id]);

	return { sendView };
}
